import React from 'react';
import styled from 'styled-components';
import { Heading1, Margin, P, theme } from '@ovotech/element-v5';
import { breakpoints } from '@/src/utils/mediaQuery';
import { Coin } from './Coin';
import useWindowDimensions from '@/src/utils/hooks/useWindowDimensions';
import {
  RewardsCard,
  RewardsCardContent,
  RewardsCardTextContent,
  RewardsCardImageContainer,
} from './RewardsCard';

const Heading = styled(Heading1)`
  color: ${({ theme }) => theme.colors.brand.midnight};
`;

const Subheading = styled(P)`
  color: #635e58;
  font-size: ${theme.font.size.xl.mediaQuery.lg};
  margin-right: 58px;

  @media ${breakpoints.smallDown} {
    font-size: ${theme.font.size.md.mediaQuery.sm};
    margin-right: 0;
  }
`;

export const Hero = () => {
  const { isMobile } = useWindowDimensions();

  return (
    <RewardsCard>
      <RewardsCardContent>
        <RewardsCardTextContent>
          <Heading>Get rewards with Beyond</Heading>
          <Margin top={4}>
            <Subheading>
              Rewards just for being with us. Exclusively in the OVO app.
            </Subheading>
          </Margin>
        </RewardsCardTextContent>

        <RewardsCardImageContainer>
          <Coin size={isMobile ? '82' : '146'} />
        </RewardsCardImageContainer>
      </RewardsCardContent>
    </RewardsCard>
  );
};
